import type { OriginalSizeSingle } from '@shared/ui/list/types';

export const buildFramedSizeParam = (framedSizes: OriginalSizeSingle[]) => {
  const framedMapped = framedSizes
    .map((originalSize) => Number(originalSize).toFixed(0))
    .filter(Number)
    .join('cm x ');
  return framedMapped.length ? framedMapped + 'cm' : 'No framed';
};
